import {
    LoggerConfiguration,
    LoggerType, LoggerMode,
    SensorCode, LoggerStatus,
} from 'app/enums/label.enums'

import {
    Company,
} from 'app/Apps/ContactManagement/Companies/Companies.types'

type ConfigLoggerOption = {
    value: string,
    label: string
}

export type ConfigLogger = {
    title: string,
    name: string,
    loggerType?: LoggerType,
    sensorCodes?: SensorCode[],
    positions?: string[],
    options: ConfigLoggerOption[]
}

type LoggerTypeDetails = {
    changedOn?: string,
    createdOn?: string,
    dataTypes?: string[],
    deleted?: boolean
    hasMultipleSensors: boolean,
    loggerType?: LoggerType
    positionConfiguration: LoggerConfiguration[],
    priority?: number,
}

type LoggerBase = {
    containerSerialNumber?: string,
    id?: number,
    lastEventDoorOnUtc?: number,
    lastMeasuredOnUtc?: number,
    loggerNumber?: string,
    loggerQrCode?: string,
    loggerStatus?: LoggerStatus,
    loggerType?: LoggerType,
    loggerMode?: LoggerMode,
    hardwareVersion?: string,
    softwareVersion?: string,
}

export type LoggerTable = LoggerBase & {
    gatewayGatewayId?: number,
    gatewayImeiMac?: string,
    locationName?: string,
    batteryVoltage?: string,
    rentingCompany?: Company,
    createdOn?: string,
    loggerMode?: LoggerMode,
    lastActivatedOn: string,
    isTestingLogger?: boolean,
    productionBatchNumber?: string,
}

export type LoggerResponse = LoggerBase & {
    allowedSensorCodes?: SensorCode[],
    calibrationDocuments?: any[],
    changedOn?: string,
    containerId?: number,
    createdBy?: string,
    createdOn?: string,
    deleted?: boolean,
    loggerTypeDetails?: LoggerTypeDetails
    reservedForUsers?: any[],
    batteryVoltage?: string,
    gateway?: {
        id: number,
        locationRemark: string,
        location: {
            id: string,
        },
    },
    location?: {id: number}
    rentingCompany?: Company,
    lastActivatedOn?: string,
    lastCalibratedOn?: string,
    isTestingLogger?: boolean,
    transmissionRateSecondsStatic?: number,
    transmissionRateSecondsMobile?: number,
    measurementIntervalSeconds?: number,
}

export default LoggerType
